import {CartItemType} from 'desktop/pages/cart/types';

export const PAGE_NAME_FOR_VIZURY = {
    CART: 'shopping_cart',
    TYP: 'thank_you',
} as const;

const arrayToObject = Object.values(PAGE_NAME_FOR_VIZURY);
export type PagesLocationType = (typeof arrayToObject)[number];
export type VizuryDataFromTYPType = {
    id: string;
    revenue: string;
    orderedItems: CartItemType[];
};

export const VALUE_PAGE_FOR_VIZURY: {[key: string]: string} = {
    shopping_cart: 'cartpage',
    thank_you: 'thankyoupage',
};
